const REFUSAL_TEXT = {
    insufficient_history: "Not enough minute history yet",
    reentry_blocked: "Waiting out the 10-minute pause after a stop in this pool",
    high_volatility: "Volatility is too high to enter",
    far_from_mean: "Price is too far from the 2-hour mean",
    strong_trend: "The trend is too strong to enter",
    no_candidate: "No pool passed every filter",
    catalog_unavailable: "The pool catalog is unavailable",
    minute_history_unavailable: "Minute history is unavailable",
    price_unavailable: "The current price is unavailable",
    below_minimum: "Available capital is below the $50 minimum entry",
    balance_unavailable: "The free USDC balance could not be read yet",
    scan_error: "The scan failed with an internal error",
    sol_reserve: "SOL cannot cover the fees and rent of another opening above the reserve",
};
const INSUFFICIENT_TEXT = {
    no_history: "no minute history yet",
    history_too_recent: "history starts too recently",
    too_few_blocks: "fewer than two full 2 h blocks",
    flat_baseline: "the 24 h baseline is flat",
};
/** `filter_unavailable`'s `metric`: the expensive filter that could not be read, as a full clause. */
const FILTER_UNAVAILABLE_TEXT = {
    pool_age: "Pool age is unavailable",
    permissions: "Token permissions are unavailable",
    effective_lps: "Effective LP count is unavailable",
};
/** The scan read a `data-unavailable` outage could not do, as a phrase for "Cannot check <what>". */
const DATA_READ = {
    catalog: "the pool catalog",
    pool_age: "the pool age",
    permissions: "the token permissions",
    effective_lps: "the effective LP count",
    history: "the minute price history",
    price: "the current price",
    wallet: "the wallet balance",
    quote: "the sizing quote",
    scan: "the scan",
};
/** Provider reason codes in words; anything else is left out, never printed raw. */
const PROVIDER_REASON = {
    rate_limited: "RPC rate limiting",
    rpc_unavailable: "RPC unavailable",
    rpc_lag: "RPC lagging",
    queue_timeout: "request queue timeout",
    queue_full: "request queue full",
    snapshot_mismatch: "inconsistent snapshot",
};
/** A provider reason code in words, when known; an unknown or absent reason is never printed raw. */
export function providerReasonText(reason) {
    return reason !== null ? PROVIDER_REASON[reason] : undefined;
}
/**
 * What a `data-unavailable` outage could not read, named by the failed read itself: one refusal
 * code (`price_unavailable`) comes from several reads.
 */
export function dataReadText(read) {
    return DATA_READ[read] ?? "pool data";
}
function filterUnavailableText(refusal) {
    const base = (refusal.metric !== null ? FILTER_UNAVAILABLE_TEXT[refusal.metric] : undefined) ??
        "A pool filter is unavailable";
    const reason = providerReasonText(refusal.value);
    return reason ? `${base} (${reason})` : base;
}
/** Design 47 section 4: every refusal names the number and the threshold behind it. */
export function refusalText(refusal) {
    if (refusal.code === "filter_unavailable")
        return filterUnavailableText(refusal);
    const base = REFUSAL_TEXT[refusal.code];
    // The server's sanitized error text (`RangeError: Invalid price`), rendered as text.
    if (refusal.code === "scan_error")
        return refusal.value !== null ? `${base} (${refusal.value})` : base;
    if (refusal.insufficient)
        return `${base} (${INSUFFICIENT_TEXT[refusal.insufficient] ?? refusal.insufficient})`;
    if (refusal.value !== null && refusal.threshold !== null)
        return `${base} · ${refusal.value} vs ${refusal.threshold}`;
    return base;
}
